import Secrets from '../../services/Secrets';
import Vue from 'vue';

const addModel = function (state, model) {
  // data mutate
  model.text = model.name;
  delete model.name;
  model.retrieved = false;
  Vue.set(state.all, model.id, model);
};
const retrieveModel = function (state, model) {
  model.text = model.name;
  delete model.name;
  model.retrieved = true;
  Vue.set(state.all, model.id, model);
};

const state = {
  all: {},
};

const getters = {
  all: () => {
    return state.all;
  },
  getById: state => id => {
    return state.all[id];
  }
};

const actions = {
  getSecretTemplates({commit}) {
    return Secrets.getSecretTemplates().then(data => commit('receiveAll', data.records));
  },
  getSecretTemplate({commit}, payload) {
    return Secrets.getSecretTemplate(payload).then(data => commit('retrieve', data));
  },
  clearState({commit}) {
    return commit('clearState');
  },
};

const mutations = {
  clearState(state) {
    state = {
      all: {},
    };
  },
  receiveAll(state, models) {
    models.forEach(model => {
      addModel(state, model);
    });
  },
  retrieve(state, model) {
    retrieveModel(state, model);
  },
  loadOffline(state, store) {
    state.all = store.all;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/secrettemplates.js